import {
  getFromStore,
  resetAllStore,
  resetStore,
  setToStore,
} from '@/data/local-store';
import { setButton } from '@/data/submit-button';
import {
  localStoreFormDataName,
  localStoreSelectedCoffeeName,
} from '@/models/local-store';
import { Mod } from '@/models/mod';
import { Steps } from '@/models/steps';
import store from '.';

const merge = (key: string, arr: any[]): string[] => {
  let newArr: string[] = [];
  arr.forEach((item: any) => {
    newArr = [...newArr, ...new Set(item[key] as string[])];
  });
  return [...new Set(newArr)];
};

const getArr = (obj: any): string[] => {
  const arr: string[] = [];
  Object.keys(obj).forEach((key: string) => {
    if (obj[key]) {
      arr.push(key);
    }
  });
  return arr;
};

const dataFromStore = getFromStore(localStoreFormDataName) || {
  [Steps.MOD]: null,
  [Steps.ROASTIN]: null,
  [Steps.FLAVOUR]: null,
  [Steps.AFTERTASTE]: null,
  [Steps.AROMA]: null,
  [Steps.ACIDITY]: null,
  [Steps.AMOUNT]: null,
  [Steps.LABEL]: null,
  [Steps.SUMMARY]: null,
  [Steps.PORTION]: null,
};

export default {
  form: {
    state: {
      mod: dataFromStore[Steps.MOD],
      data: dataFromStore,
      complete: false,
      result: {},
    },
    mutations: {
      setMod: (state: { data: any; mod: Mod }, mod: Mod) => {
        state.mod = mod;
        state.data[Steps.MOD] = mod;
      },

      resetData: (state: { data: any; mod: Mod }, mod: Mod) => {
        state.mod = mod;
        state.data = {
          [Steps.MOD]: mod,
          [Steps.ROASTIN]: null,
          [Steps.FLAVOUR]: null,
          [Steps.AFTERTASTE]: null,
          [Steps.AROMA]: null,
          [Steps.ACIDITY]: null,
          [Steps.AMOUNT]: null,
          [Steps.LABEL]: null,
          [Steps.SUMMARY]: null,
          [Steps.PORTION]: null,
        };
        resetStore(localStoreSelectedCoffeeName);
        setToStore(state.data, localStoreFormDataName);
      },

      setToForm: (
        state: { [key: string]: any },
        data: { key: string; value: string }
      ) => {
        state.data[data.key] = data.value;
        setToStore(state.data, localStoreFormDataName);
      },

      setComplete(state: { complete: boolean }, complete: boolean) {
        state.complete = complete;
      },

      setResult(state: { result: object }, result: object) {
        state.result = result;
      },
    },
    getters: {
      getMod: (state: { mod: Mod }) => {
        return state.mod;
      },

      getFormData: (state: { data: Steps }) => {
        return state.data;
      },

      isComplete: (state: { complete: boolean }) => {
        return state.complete;
      },

      getResult: (state: { result: object }) => {
        return state.result;
      },
    },
    actions: {
      setToForm: (
        context: { commit: any },
        data: { key: string; value: string }
      ) => {
        context.commit('setToForm', data);

        if (data.key === Steps.MOD) {
          context.commit('setMod', data.value);
        }
      },

      submitForm: (context: { state: any; commit: any }) => {
        const allData = (store as any).state.data.data;
        const form = context.state.data;
        const selectedCoffee = store.getters.getSelectedCoffeeListWithPercent.map(
          (item: any) => {
            return {
              id: item.code,
              percent: item.value,
              name: item.name,
              [Steps.FLAVOUR]: getArr(item[Steps.FLAVOUR]),
              [Steps.AFTERTASTE]: getArr(item[Steps.AFTERTASTE]),
              [Steps.AROMA]: getArr(item[Steps.AROMA]),
              [Steps.ACIDITY]: getArr(item[Steps.ACIDITY]),
            };
          }
        );

        const formData: any = {};
        Object.keys(form).forEach((key: any) => {
          const item = form[key];
          if (
            key !== Steps.PORTION &&
            key !== Steps.MOD &&
            key !== Steps.SUMMARY
          ) {
            if (item && key !== Steps.AMOUNT) {
              formData[key] = item;
            } else if (key === Steps.LABEL) {
              formData[key] = 'empty';
            } else if (key === Steps.AMOUNT) {
              formData[key] = item[0];
            } else {
              formData[key] = merge(key, selectedCoffee);
            }
          }
        });

        const result = {
          article: allData.baseProducts[form[Steps.AMOUNT]]['id'],
          coffee: selectedCoffee,
          formData,
        };

        context.commit('setResult', result);
        // context.commit('setComplete', true);
        resetAllStore();

        setButton(result);
        
        console.log(result);
      },
    },
  },
};
